module.exports = __webpack_public_path__ + "img/r5.d5426131.jpg";